require('../../landing/search/_result-item');
require('../../landing/search/_preview-modal');
require('../../landing/search/_listen-modal');

$(() => {
  $.urlParam = function (name) {
    const results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(window.location.href);
    if (results == null) {
      return null;
    }

    return results[1] || 0;
  };

  let currentListId = null;
  let currentListItemId = null;

  $('.select-listEdit').select2({
    placeholder: __('Select a list to edit'),
    minimumResultsForSearch: Infinity
  });

  $('.select-listEdit').on('change', function (e) {
    if ($('#lists').children('option').length > 1) {
        	const id = $(this).val();

      $('#search-title').find('button').button('loading');

      $('#search-overlay').show();

      $.post(loadItemsUrl, {
        id
      }, (data) => {
        $('#list-items-cnt').sortable({
          axis: 'y',
          handle: '.sort-handle',
          update() {
            const data = $(this).sortable('serialize');
            $.post(
              reorderListUrl,
              data,
              (data) => {
                if (data.isError == 1) {
                  toastr.error(data.msgError);
                }
              }, 'json'
            );
          }
        });
        $('#search-overlay').hide();

        $('#search-title').find('button').button('reset');

        currentListId = id;

        $('#list-mgmt').show();
        $('#list-items-cnt').html(data.itemsHtml);
        $('.list-title').html(data.title);
        $('input[name="newTitleList"]').val(data.title);

        if (data.isEmpty == 0) {
          $('.btn-report-all').show();
        } else {
          $('.btn-report-all').hide();
        }

        $('.report-all-ctrl').show();

        if (data.isError) {
          toastr.error(data.msgError, 'Error');
        }
      }, 'json');
    }
  });

  $('#btnDelete').click(() => {
    $.post(deleteListUrl, {
      id: currentListId
    }, (data) => {
      if (data.isError == 1) {
        toastr.error(data.msgError);
      } else {
        $('#deleteListModal').modal('hide');

        $(`#lists option[value="${currentListId}"]`).remove();
        currentListId = $('#lists option:nth-child(2)').attr('value');

        $('.select-listEdit').val(currentListId);
        $('.select-listEdit').trigger('change');

        if (isNaN(currentListId)) {
          currentListId = null;
          $('.report-all-ctrl').hide();
          $('#list-mgmt').hide();
          $('#list-items-cnt').html(`<div class="alert alert-info alert-tmp" role="alert">${__('Please, select a list to edit.')}</div>`);
        } else {
          $('.select-listEdit').trigger('select2:select');
        }
      }
    }, 'json');
  });

  $('#listRenameForm').submit(function (e) {
    const form = $(this);
    const dataArr = $(this).serializeArray();

    $(this).find('button').button('loading');

    $.post(renameListUrl, {
      id: currentListId,
      dataArr
    }, (data) => {
      form.find('button').button('reset');
      clearErrors(form);

      const response = data;
      if (response.isError == 1) {
        toastr.error(response.msgError, 'Error');

        if (response.formErrorMessagess && response.formErrorMessagess.length !== 0) {
          $.each(response.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        toastr.success(__('List has been renamed'), __('Success'));

        $('#renameListModal').modal('hide');

        $('.list-title').html(data.title);
        $('input[name="newTitleList"]').val(data.title);

        $(`#lists option[value="${currentListId}"]`).text(data.title);

        $('.select-listEdit').select2('destroy');
        $('.select-listEdit').select2({
          placeholder: __('Select a list to edit'),
          minimumResultsForSearch: Infinity
        });
      }
    });

    e.preventDefault();
  });

  $('#listCreateForm').submit(function (e) {
    const form = $(this);
    const dataArr = $(this).serializeArray();

    $(this).find('button').button('loading');

    $.post(urlCreateList, {
      id: currentListId,
      dataArr
    }, (data) => {
      form.find('button').button('reset');
      clearErrors(form);

      const response = data;
      if (response.isError == 1) {
        toastr.error(response.msgError, 'Error');

        if (response.formErrorMessagess && response.formErrorMessagess.length !== 0) {
          $.each(response.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              form.find(`[name="${elementId}"]`).parent().addClass('has-error');
              form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        toastr.success(__('List has been successfully added'), __('Success'));
        form.find('input[name="list-name"]').val('');

        const newList = new Option(response.name, response.id, true, true);
        $('.select-listEdit').append(newList).trigger('change');
        $('#createListModal').modal('hide');
      }
    });

    e.preventDefault();
  });

  $('#deleteModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);

    currentListItemId = btn.data('id-item');
    $('#delete-item-title').html(btn.data('title'));
  });

  $('#createListModal').on('show.bs.modal', (e) => {
    $('.select-listEdit').select2('close');
    clearErrors($('#createListForm'));
  });

  $('#btnDeleteItem').click(function () {
    const btnRfc = $(this);

    btnRfc.button('loading');

    $.post(deleteListItemUrl, {
      id: currentListItemId
    }, (data) => {
      btnRfc.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError);
      } else {
        $('.select-listEdit').trigger('change');
        currentListItemId = null;
        $('#deleteModal').modal('hide');
      }
    });
  });

  $('#btnDeleteCancel').click((e) => {
    $('#deleteListModal').modal('hide');

    e.preventDefault();
  });

  $('#btnRenameCancel').click((e) => {
    $('#renameListModal').modal('hide');

    e.preventDefault();
  });

  $('#btnCreateCancel').click((e) => {
    $('#createListModal').modal('hide');

    e.preventDefault();
  });

  $('#process-download').click((e) => {
    if (currentListId != null) {
      $('#downloadAllModal #navigation').hide();
      $('#downloadAllModal #loading').show();
      $('#downloadAllModal').modal('show');

      $.get(`${downloadAllUrl}/${currentListId}`, (data) => {
        if (data.isError === 1) {
          $('#downloadAllModal').modal('hide');
          toastr.error(data.msgError, 'Error');
        } else {
          $('#downloadAllModal #navigation').show();
          $('#downloadAllModal #loading').hide();
        }
      }, 'json');
    }

    e.preventDefault();
  });

  checkIfIdAvailable();

  function checkIfIdAvailable() {
    const id = parseInt($.urlParam('id'));

    if (!isNaN(id)) {
      currentListId = id;

      $('.select-listEdit').val(currentListId);
      $('.select-listEdit').trigger('change');
      $('.select-listEdit').trigger('select2:select');
    }
  }

  function clearErrors(form) {
    form.find('.help-block').remove();
    form.find('.form-group').removeClass('has-error');
  }
});
